import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { getLocalizedStrings } from '../centralizedLocalizedString';
import SceButton from '../../Common/CommonComponents/sceButton.js';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Classes from './CustomerPreference.scss';
import Styles from '../Centralized.scss';
import AlertCard from '../common/AlertCard';
import SceUpdates from './SceUpdates';
import LanguageCard from './LanguageCard';

class CustomerPreference extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('CustomerPreference');
    this.state = {
      maskedMailId: "",
      errorResponse: "",
      showOnLoadError: "",
    };
  }
  componentWillMount() {
    this.setState(
      {
        resp: this.props.res,
        errorResponse: this.props.errorResponse,
        isMkgEnrolled: "",
      },
      () => {
        this.handle();
      }
    );
  }
  componentWillReceiveProps(nextProps) {
    this.setState({resp: nextProps.res, errorResponse: nextProps.errorResponse},
      () => {this.handle();});
  }
  //error
  launchErrorMarketing = () => {
    if (this.props.marketRefresh) {
      return false;
    } else {
      if (this.state.errorResponse.length) {
        let maps = new Map(this.state.errorResponse.map(o => [o.programDetails, o]));
        let programError = maps.get("CPC_PROGRAMS_MARKETING");
        if (!_.isEmpty(programError)) {
          return true;
        }
      }
    }
  };

  handle = () => {
    const currState = { ...this.state };
    let marketingPrefSession = app.appService.getSessionstorage('marketingPref');
    currState.showOnLoadError = this.launchErrorMarketing();
    if (_.isEmpty(this.state.resp.marketingPref) && _.isEmpty(marketingPrefSession)) {
      let customerDetails = app.appService.getSessionstorage('customerData');
      let mailId = _.find(customerDetails.emailAddresses, function(eachAddress){
        return eachAddress.standardIndicatorEmail === 'X';
      });
      mailId = mailId ? mailId.email : '';
      currState.isMkgEnrolled = mailId ? true : false;
      currState.maskedMailId = app.appUtil.FormatUtil.maskEmailIDWithXFashion(mailId);
      currState.maskedMailId = mailId.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
    }
    else {
      let marketingPrefObj = this.state.resp.marketingPref[0] || marketingPrefSession[0];
      let validToDate = new Date(parseInt(marketingPrefObj.validToDate.substr(6)));
      let currPstDate = app.appUtil.DateUtil.getPSTDate(new Date());
      if(validToDate < currPstDate){
        let mailId = marketingPrefObj.email_id;
        currState.isMkgEnrolled = true;
        currState.maskedMailId = app.appUtil.FormatUtil.maskEmailIDWithXFashion(mailId);
        currState.maskedMailId = mailId.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
      } else {
        currState.maskedMailId = "";
        currState.isMkgEnrolled = false;
      }      
    }
    this.setState(currState);
  };

  render() {
    return (
      <div>
        <div className={Styles.preferenceLabel}>
          {this.strings.CustomerPreferenceLabel}
        </div>
        {/* Language Card starts */}
        <LanguageCard cpcResponse={this.state.resp} guestUser={this.props.guestUser} staticContent={this.props.staticContent.notiLang} />
        {/* Language Card Ends */}
        {/* Marketing preferences card Starts */}
        <div>
          <SceUpdates AlertName="SCE Updates" AlertExp="Get updates about rebates, savings, and promotions." handleMarket={this.props.handleMarketingPref}
            isMkgEnrolled={this.state.isMkgEnrolled}
            maskedMail={this.state.maskedMailId} staticContent={this.props.staticContent.sceUpdates}
            ErrorOnload={this.state.showOnLoadError} handleMarkRefresh={this.props.handleRefreshMkpr} marketregrefresh={this.props.marketregrefresh} marketRefresh={this.props.marketRefresh} handlerefreshtxt={this.props.handlerefreshtxt} />
        </div>
        {/* Marketing preferences card Ends */}
      </div>
    );
  }
}
export default CustomerPreference;
